var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueButtomArrowR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 8,
  viewBox: "0 0 13 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.3951 0.963491C11.6881 0.670519 12.1631 0.670631 12.4559 0.963741C12.7485 1.25662 12.7485 1.7312 12.4558 2.02399L7.20862 7.27294C7.11606 7.3661 7.00598 7.44003 6.88473 7.49048C6.76348 7.54092 6.63345 7.56689 6.50212 7.56689C6.3708 7.56689 6.24077 7.54092 6.11952 7.49048C5.99827 7.44003 5.88819 7.3661 5.79563 7.27294L0.545718 2.02395C0.252963 1.73124 0.252943 1.25663 0.545673 0.963897C0.838365 0.671204 1.31291 0.671182 1.60563 0.963848L6.50063 5.85794L11.3951 0.963491Z",
  fill: "#003399"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueButtomArrowR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blue_buttom_arrow-r.78d8f6931179ccb1a5af81148f67941d.svg";